<template>
	<li>
		<a-tooltip
			v-if="tooltip"
			placement="right"
		>
			<template slot="title">
				<span>{{ item.title }}</span>
			</template>

			<div
				:class="{
					[styles.air__menuLeft__item]: true,
					[styles.air__menuLeft__item__active]: item.key === activeItem
				}"
			>
				<router-link
					v-if="item.url"
					:to="item.url"
					:class="styles.air__menuLeft__link"
				>
					<fa-icon
						v-if="item.icon"
						:icon="item.icon"
						:class="{[item.icon]: true,[styles.air__menuLeft__icon]: true}"
					/>
					<span>{{ item.title }}</span>
				</router-link>
				<a
					v-if="!item.url"
					href="javascript: void(0);"
					:class="styles.air__menuLeft__link"
				>

					<fa-icon
						v-if="item.icon"
						:icon="item.icon"
						:class="{[item.icon]: true,[styles.air__menuLeft__icon]: true}"
					/>
					<span>{{ item.title }}</span>
				</a>
			</div>
		</a-tooltip>
		<template v-else>
			<div
				:class="{
					[styles.air__menuLeft__item]: true,
					[styles.air__menuLeft__item__active]: item.key === activeItem,
				}"
			>
				<router-link
					v-if="item.url"
					:to="item.url"
					:class="styles.air__menuLeft__link"
				>
					<fa-icon
						v-if="item.icon"
						:icon="item.icon"
						:class="{[item.icon]: true,[styles.air__menuLeft__icon]: true}"
					/>
					<span>{{ item.title }}</span>
				</router-link>
				<a
					v-if="!item.url"
					href="javascript: void(0);"
					:class="styles.air__menuLeft__link"
				>
					<fa-icon
						v-if="item.icon"
						:icon="item.icon"
						:class="{[item.icon]: true,[styles.air__menuLeft__icon]: true}"
					/>
					<span>{{ item.title }}</span>
				</a>
			</div>
		</template>
	</li>
</template>

<script>
export default {
	name: 'Item',
	props: {
		item: Object,
		styles: Object,
		activeItem: String,
		tooltip: { type: Boolean, default: false }
	}
};
</script>
